var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isTablet
    ? _c(
        "div",
        { staticClass: "gfu-featured-projects" },
        _vm._l(_vm.chunks, function (chunk) {
          return _c(
            chunk.component,
            _vm._b(
              { key: chunk.projectID, tag: "component" },
              "component",
              chunk,
              false
            )
          )
        }),
        1
      )
    : _c(
        _vm.firstChunk.component,
        _vm._b(
          { tag: "component", staticClass: "gfu-featured-projects" },
          "component",
          _vm.firstChunk,
          false
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }